<template>
  
  <div class="1">
    <div class="main-content">
      <div class="block block3" @click="openVan(1)"><i>物流行业信息咨询智能问答系统</i><img src="../../../../assets/coursePage/ai2/box6/launch.png"/><img class="em" src="../../../../assets/coursePage/ai2/box6/update2.svg"/></div>
      <div class="block block3" @click="openVan(4)">新零售行业评价决策系统<img src="../../../../assets/coursePage/ai2/box6/launch.png"/></div>
      <div class="block block3" @click="openVan(3)">大健康行业智能问诊系统<img src="../../../../assets/coursePage/ai2/box6/launch.png"/></div>
      <div class="block block3" @click="openVan(5)">新媒体行业评论智能分类与信息抽取系统<img src="../../../../assets/coursePage/ai2/box6/launch.png"/></div>
    </div> 
    <div class="title-icon"><i>多模态大模型<img class="add" src="../../../../assets/coursePage/ai2/box6/add.svg"/></i></div>
    <div class="main-content-flow">
      <div class="bottom">
        <h1 class="title">
          <i></i>
          <p><em>腾讯--多模态大模型开发基础<img class="add" src="../../../../assets/coursePage/ai2/box6/update.svg"/></em></p>
        </h1>
        <div class="content">
          <div class="wrapper">
            <span>
              <a>图像生成背景介绍</a>
              <a>Stable Diffusion原理</a>
              <a>腾讯云在业界中应用</a>
            </span>
          </div>
        </div>
        <div class="main-content">
          <div class="block block2" style="text-align: left;">文生图、图生图、图生动漫.腾讯云StableDiffusion应用实践</div>
          <div class="block block2">StableDiffusion多模态大模型文生图创作辅助系统</div>
        </div>
      </div>
      
    </div>
    
  </div>       
</template>

<script>
import pageTitle from "../../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  
  methods: {
    openVan(number) {
      this.$emit('openVan',number)
    },
    
  },
};
</script>

<style lang="less" scoped>
@import "index.less";
.main-content{margin-top: 16px;
  .block{
    margin-right: 0 !important;
    text-align: left !important;
  }
}
</style>